export type Phase =
  | 'RAPID'  
  | 'IDEA'
  | 'PREANALYSIS'
  | 'SPECIFICATION'
  | 'DEVELOPMENT'
  | 'IMPLEMENTATION'
  | 'OPERATION'
  | 'DECOMMISSIONED';

export const PhaseLabels: { [x in Phase]: string } = {
  RAPID: '共有（フェーズなし）',
  IDEA: 'アイデア',
  PREANALYSIS: '事前分析',
  SPECIFICATION: '仕様策定',
  DEVELOPMENT: '開発',
  IMPLEMENTATION: '導入',
  OPERATION: '運用中',
  DECOMMISSIONED: '運用終了'
};

export const PhaseKeys: { [phase in Phase]: phase } = {
  RAPID: 'RAPID',
  IDEA: 'IDEA',
  PREANALYSIS: 'PREANALYSIS',
  SPECIFICATION: 'SPECIFICATION',
  DEVELOPMENT: 'DEVELOPMENT',
  IMPLEMENTATION: 'IMPLEMENTATION',
  OPERATION: 'OPERATION',
  DECOMMISSIONED: 'DECOMMISSIONED'
};

export const PhaseOrder = [
  'RAPID',
  'IDEA',
  'PREANALYSIS',
  'SPECIFICATION',
  'DEVELOPMENT',
  'IMPLEMENTATION',
  'OPERATION',
  'DECOMMISSIONED',
];
